import { BuilderConfig } from '@/types/builder';
import RoomstayBlogCiaaLeadForm, { RoomstayBlogCiaaLeadFormProps } from './roomstay-blog-ciaa-lead-form';

export const config = {
    name: 'CIAA Lead Form',
    inputs: [
        {
            name: 'formId',
            type: 'string',
            default: 'ciaa-lead-form',
            required: true,
            regex: {
                pattern: '^S+$',
                message: 'Input must not contain spaces or whitespace.',
            },
        },
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'description',
            type: 'string',
        },
        {
            name: 'successMessage',
            type: 'string',
        },
        {
            name: 'autoResetSeconds',
            type: 'number',
            helperText: 'Seconds before the success message hides and the form resets. Leave empty to keep the message visible.',
        },
    ],
};

const builderConfig: BuilderConfig<RoomstayBlogCiaaLeadFormProps> = {
    component: RoomstayBlogCiaaLeadForm,
    config,
};

export default builderConfig;
